/**
 * 샛별 보너스 금액 표기 (studio#2524). 응답은 숫자만 준다.
 *
 * 서버 값 그대로 천 단위 구분만 한다. 회수(clawback)·월 합계(monthTotal)가 드물게 소수(-320.5)로 와도
 * 반올림·내림하지 않는다 — BE 답변(10/8 #bbt_project 스레드): "fe 는 서버값을 그대로".
 *
 * 숫자가 아니면(필드 누락·이름 변경) '-' — 그대로 두면 'NaN' 이 금액 칸에 찍히고, throw 가 아니라 에러 경계도 못 잡는다.
 */
export const formatAmount = (value: number) => (Number.isFinite(value) ? value.toLocaleString('ko-KR') : '-');
